import React from "react";
import Watermark from "../Watermark/Watermark";
import Sidebar from "../Sidebar/Sidebar";
import MarketplaceSidebar from "../MarketplaceSidebar/MarketPlaceSidebar";
import Navbar from "../NavBar/Navbar";

const AppShell = ({ children }) => (
  <div className="app-shell">
    <Watermark text="HRLabs" />
    <Sidebar />
    <MarketplaceSidebar />
    <Navbar />
    <main className="app-shell__content">
      <div className="app-shell__page">{children}</div>
    </main>
  </div>
);

export default AppShell;
